module.exports = __webpack_public_path__ + "assets/img/main1.4adc659e.png";